import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { KPI } from '../../types/indicadores';
import { kpiService } from '../../services';

const fields: ResourceField<KPI>[] = [
  { name: 'nome', label: 'Nome', required: true },
  { name: 'unidade', label: 'Unidade', type: 'select', options: [{ label: '%', value: 'PORCENTAGEM' }, { label: 'Unidades', value: 'UNIDADES' }, { label: 'Horas', value: 'HORAS' }, { label: 'Reais', value: 'REAIS' }, { label: 'Metros', value: 'METROS' }, { label: 'Outros', value: 'OUTROS' }] },
  { name: 'meta_valor', label: 'Meta', type: 'number' },
  { name: 'formula', label: 'Fórmula', type: 'textarea' },
  { name: 'descricao', label: 'Descrição', type: 'textarea' }
];

export const KpisFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo KPI"
    description="Configure um indicador chave."
    fields={fields}
    service={ kpiService }
    redirectPath="/admin/indicadores/kpis"
    cancelPath="/admin/indicadores/kpis"
  />
);
